import cn from 'bem-cn';
import './index.less';

export var assistant = cn('assistant');

export var messages = assistant('messages');
export var message = assistant('message');
export var messageWrapper = assistant('messageWrapper');
export var messageBubble = assistant('bubble');

export var card = message('card');

export var feedbackWrapper = assistant('feedbackWrapper');
export var feedback = assistant('feedback');
export var feedbackPositive = feedback('positive');
export var feedbackNegative = feedback('negative');
export var textPart = message('textPart');
export var status = message('status');
export var messageText = message('text');
export var messageButton = message('button');
export var messageListening = message('listening');
export var command = message('command');
export var commandTimer = command('timer');
export var commandFooter = command('footer');